import { PSTFieldNames } from '@src/suite/common/data-models/fields/pst-field-names';
import { FilterDef } from '@src/suite/common/data-models/navigation/filter-def';
import { ViewStateFilter } from '@src/suite/common/data-models/navigation/viewstate-filter';
import { ViewStateOptions } from '@src/suite/common/data-models/navigation/viewstate-options';
import { SingleViewStateRecord } from '@src/suite/common/data-models/records/single-viewstate-record';
import { GroupSecurityPrivs } from '@src/suite/common/data-models/service/group-security-privs';
import { OPTION_ALL } from '@src/suite/common/enums/constants';
import { ViewStateLayouts } from '@src/suite/common/enums/viewstate-layouts';
import { ViewStateTypes, ViewStateTypesEnum } from '@src/suite/common/enums/viewstate-types';
import { GlobalTablesService } from '@src/suite/common/services/global-tables-service';
import { GlobalTablesGroupSort } from '@src/suite/common/store/global-tables/global-tables.models';
import { NOMDatabase } from '@src/suite/common/store/records/records.models';

export const getLayoutOptions = (viewStateType: number, i18n, PSTGroup: GroupSecurityPrivs): ViewStateOptions => {
    const ret: ViewStateOptions = new ViewStateOptions();
    switch (viewStateType) {
        case ViewStateTypes.TOPIC:
            ret.Default = ViewStateLayouts.CARD;
            ret.Label = i18n?.PSTWebViewCardLabel;
            ret.Options = [
                { id: ViewStateLayouts.CARD, title: i18n?.PSTWebViewCardLabel },
                { id: ViewStateLayouts.CONDENSE, title: i18n?.PSTWebViewCondensedLabel },
                { id: ViewStateLayouts.TILE, title: i18n?.PSTWebViewTimelineLabel },
            ];
            if (PSTGroup?.viewUserLocationPrivileges) {
                ret.Add({ id: ViewStateLayouts.MAP, title: i18n?.PSTWebViewMapLabel });
            }
            break;
        case ViewStateTypes.ASSIGNMENT:
            ret.Default = ViewStateLayouts.CARD;
            ret.Label = i18n?.PSTWebViewCardLabel;
            ret.Options = [
                { id: ViewStateLayouts.CARD, title: i18n?.PSTWebViewCardLabel },
                { id: ViewStateLayouts.CONDENSE, title: i18n?.PSTWebViewCondensedLabel },
            ];
            break;
        case ViewStateTypes.SCRIPT:
            ret.Default = ViewStateLayouts.CARD;
            ret.Label = i18n?.PSTWebViewCardLabel;
            ret.Options = [{ id: ViewStateLayouts.CARD, title: i18n?.PSTWebViewCardLabel }];
            break;
        case ViewStateTypes.ROLIST:
            ret.Default = ViewStateLayouts.CONDENSE;
            ret.Label = i18n?.PSTWebViewCondensedLabel;
            ret.Options = [
                //{ id: ViewStateLayouts.CARD, title: i18n?.PSTWebViewCardLabel },
                // { id: ViewStateLayouts.TILE, title: i18n?.PSTWebViewTimelineLabel },
                { id: ViewStateLayouts.CONDENSE, title: i18n?.PSTWebViewCondensedLabel },
            ];
            break;
        case ViewStateTypes.RSSFEED:
        case ViewStateTypes.APFEED:
        case ViewStateTypes.FTPFEED:
        case ViewStateTypes.TWITTERFEED:
        case ViewStateTypes.MULTIPLEFEED:
        case ViewStateTypes.WIREFEED:
        case ViewStateTypes.EMAILFEED:
            ret.Default = ViewStateLayouts.TILE;
            ret.Options = [
                { id: ViewStateLayouts.CARD, title: i18n?.PSTWebViewCardLabel },
                { id: ViewStateLayouts.TILE, title: i18n?.PSTWebViewTimelineLabel },
                { id: ViewStateLayouts.CONDENSE, title: i18n?.PSTWebViewCondensedLabel },
            ];
            break;
        case ViewStateTypes.WIRESEARCH:
            ret.Default = ViewStateLayouts.CARD;
            ret.Options = [
                { id: ViewStateLayouts.CARD, title: i18n?.PSTWebViewCardLabel },
                { id: ViewStateLayouts.TILE, title: i18n?.PSTWebViewTimelineLabel },
                { id: ViewStateLayouts.CONDENSE, title: i18n?.PSTWebViewCondensedLabel },
            ];
            break;
        case ViewStateTypes.PUBLICATION:
            ret.Default = ViewStateLayouts.CONDENSE;
            ret.Label = i18n?.PSTWebViewCondensedLabel;
            ret.Options = [
                { id: ViewStateLayouts.CAST_CARD, title: i18n?.PSTWebViewCardLabel },
                { id: ViewStateLayouts.CONDENSE, title: i18n?.PSTWebViewCondensedLabel },
            ];
            break;
        default:
            return ret;
    }

    return ret;
};

export const getGroupByOptions = (viewStateType: ViewStateTypesEnum, groupSort: GlobalTablesGroupSort, i18n): ViewStateOptions => {
    const ret: ViewStateOptions = new ViewStateOptions();
    switch (viewStateType) {
        case ViewStateTypesEnum.TOPIC:
        case ViewStateTypesEnum.ASSIGNMENT:
        case ViewStateTypesEnum.SCRIPT:
            ret.Default = PSTFieldNames.TargetPublicationDate;
            ret.Options = groupSort?.[viewStateType]?.groupingValues || [];
            break;
        case ViewStateTypesEnum.ROLIST:
            ret.Default = PSTFieldNames.PSTModTime;
            ret.Options = [{ id: PSTFieldNames.PSTModTime, title: i18n?.PSTRundownStartTime }];
            break;
        case ViewStateTypesEnum.RSSFEED:
        case ViewStateTypesEnum.APFEED:
        case ViewStateTypesEnum.FTPFEED:
        case ViewStateTypesEnum.TWITTERFEED:
        case ViewStateTypesEnum.MULTIPLEFEED:
        case ViewStateTypesEnum.WIREFEED:
        case ViewStateTypesEnum.EMAILFEED:
            ret.Default = PSTFieldNames.PSTWirePublished;
            ret.Options = [{ id: PSTFieldNames.PSTWirePublished, title: i18n?.PSTWebSortByPubTimeLabel }];
            break;
        case ViewStateTypesEnum.WIRESEARCH: {
            ret.Default = PSTFieldNames.PSTWireType;
            ret.Options = groupSort?.[viewStateType]?.groupingValues || [];
            break;
        }
        default:
            return ret;
    }
    return ret;
};

export const getSortByOptions = (viewStateType: ViewStateTypesEnum, groupSort: GlobalTablesGroupSort, i18n): ViewStateOptions => {
    const ret: ViewStateOptions = new ViewStateOptions();
    switch (viewStateType) {
        case ViewStateTypesEnum.TOPIC:
        case ViewStateTypesEnum.ASSIGNMENT:
        case ViewStateTypesEnum.SCRIPT:
            ret.Default = PSTFieldNames.TargetPublicationDate;
            ret.Options = groupSort?.[viewStateType]?.sortingValues || [];
            break;
        case ViewStateTypesEnum.ROLIST:
            ret.Default = PSTFieldNames.PSTModTime;
            //Should be applied in SEARCH when changed
            ret.Options = [{ id: PSTFieldNames.PSTModTime, title: i18n?.PSTRundownStartTime }];
            break;
        case ViewStateTypesEnum.SEARCH: {
            ret.Default = PSTFieldNames.TargetPublicationDate;
            ret.Options = [
                { id: PSTFieldNames.PSTModTime, title: i18n?.PSTRundownStartTime },
                { id: PSTFieldNames.PSTDesk, title: i18n?.PSTWebDesksLabel },
            ];
            const topicsOptions = groupSort?.[ViewStateTypesEnum.TOPIC]?.sortingValues || [];
            const assignmentsOptions = groupSort?.[ViewStateTypesEnum.ASSIGNMENT]?.sortingValues || [];
            const scriptsOptions = groupSort?.[ViewStateTypesEnum.SCRIPT]?.sortingValues || [];

            const options = [topicsOptions, assignmentsOptions, scriptsOptions];
            const intersection = options.reduce((accumulator, currentArray) => {
                return accumulator.filter(item => currentArray.some(otherItem => item.id === otherItem.id && item.id !== PSTFieldNames.PSTModTime && item.id !== PSTFieldNames.PSTDesk));
            });

            ret.Options = [...ret.Options, ...intersection];
            break;
        }
        case ViewStateTypesEnum.RSSFEED:
        case ViewStateTypesEnum.APFEED:
        case ViewStateTypesEnum.FTPFEED:
        case ViewStateTypesEnum.TWITTERFEED:
        case ViewStateTypesEnum.MULTIPLEFEED:
        case ViewStateTypesEnum.WIREFEED:
        case ViewStateTypesEnum.EMAILFEED:
            ret.Default = PSTFieldNames.PSTWirePublished;
            ret.Options = [{ id: PSTFieldNames.PSTWirePublished, title: i18n?.PSTWebSortByPubTimeLabel }];
            break;
        case ViewStateTypesEnum.WIRESEARCH:
            ret.Default = PSTFieldNames.PSTWirePublished;
            ret.Options = groupSort?.[viewStateType]?.groupingValues || [];
            break;
        default:
            return ret;
    }
    return ret;
};

export const getDatabasesOptions = (vs: SingleViewStateRecord, pstServer: string, targetGroup: string, allGroups: { [id: string]: Group }, allGroupsArray: Array<Group>): Array<NOMDatabase> => {
    if (!vs) {
        return [];
    }
    const databases: Array<NOMDatabase> = [];
    const servers = vs.viewStateFilter?.filters?.find(filter => filter.ID === PSTFieldNames.PSTServerLocations);

    if (!servers?.Value || servers?.Value.length === 0) {
        databases.push({
            Database: pstServer,
            NOMLocations: [
                {
                    BasePath: `P_${targetGroup}\\`,
                    SearchWIP: true,
                    SearchArchives: true,
                    SearchTrash: false,
                },
            ],
        });
    } else {
        let locations: Array<string> = [];
        if (servers?.Value.length === 1 && servers?.Value[0] === OPTION_ALL) {
            locations = allGroupsArray.map(group => {
                return group.ID;
            });
        } else {
            locations = servers.Value;
        }

        locations.forEach(value => {
            const group = allGroups[value];
            if (!group) return;
            if (!databases.find(db => db.Database === group.Server)) {
                databases.push({
                    Database: group.Server,
                    NOMLocations: [
                        {
                            BasePath: `P_${group.ID}\\`,
                            SearchWIP: true,
                            SearchArchives: true,
                            SearchTrash: false,
                        },
                    ],
                });
            } else {
                databases
                    .find(db => db.Database === group.Server)
                    ?.NOMLocations.push({
                        BasePath: `P_${group.ID}\\`,
                        SearchWIP: true,
                        SearchArchives: true,
                        SearchTrash: false,
                    });
            }
        });
    }
    return databases;
};

export const filterFilterByObjectTypes = (
    filterObj: ViewStateFilter,
    objTypes: Array<number>,
    globalTablesService: GlobalTablesService
): {
    groups: Array<FilterDef>;
    filters: Array<FilterDef>;
    relationships: Array<FilterDef>;
} => {
    let filters: Array<FilterDef> = [];
    let relationships: Array<FilterDef> = [];

    for (const type of objTypes) {
        filters = [...filters, ...filterObj.filters.filter(f => globalTablesService.isObjectTypeFilter(type, f.ID))];
        relationships = [...relationships, ...filterObj.relationshipFilters];
    }

    return {
        groups: [...filterObj.groups],
        filters: [...new Map(filters.map(f => [f.ID, f])).values()],
        relationships: [...new Map(relationships.map(f => [f.ID, f])).values()],
    };
};
